export function formatUptime(uptimeSince: number): string {
    const seconds = Math.floor((Date.now() - uptimeSince) / 1000);
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}u ${minutes % 60}m`;
    const days = Math.floor(hours / 24);
    return `${days}d ${hours % 24}u`;
}

export function formatDate(iso: string): string {
    return new Date(iso).toLocaleString('nl-BE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}

export function statusLabel(status: string): string {
    const labels: Record<string, string> = {
        PROCESSED: 'Verwerkt',
        FAILED: 'Mislukt',
        DEAD_LETTER: 'Dead Letter',
        PROCESSING: 'Bezig',
        PENDING: 'Wachtend',
    };
    return labels[status] ?? status;
}
